/**
 * A module to extract the URL parameters and expose them in an object.
 */

/** @type Object<string, string> */
export const Params = {};

const search = document.location.search;
if (search && search[0] === '?') {
  const args = search.substring(1).split('&');
  for (let arg of args) {
    const kv = arg.split('=');
    if (kv.length == 2) {
      const key = decodeURIComponent(kv[0]);
      const val = decodeURIComponent(kv[1]);
      Params[key] = val;
    }
  }
}
